import { $t } from '@/i18n';
import { message } from '@utils/wuji-message';
import offlineService from '@/services/offline';
import {
  INITTOTAL,
  INITPAGE,
  OFFLINESTATE,
  MESSAGES,
} from '@/pages/project/projectConfig/offline/const';

const PAGE_SIZE = 10;
const SUCCESS = 'Success';
export default {
  state: {
    offlineList: [],
    semvers: [],
    total: INITTOTAL, // 总数
    page: INITPAGE, // 当前页
    showOfflineModal: false, // 页面选择框
  },
  getters: {
  },
  actions: {
    async fetchOfflineList({ commit, rootState }, { projectId, page = 1, filter = '' } = {}) {
      try {
        const projectID = projectId || rootState.project.projectInfo?.id;
        const { total } = await offlineService.fetchOfflineList(projectID, {
          filter,
          count: 1,
        });
        // 存储调整后的page,处理边界问题
        let adjustedPage = page;
        const totalPages = Math.ceil(total / PAGE_SIZE);
        if (adjustedPage > totalPages) {
          adjustedPage = totalPages;
        }
        const newList = await offlineService.fetchOfflineList(projectID, {
          page: adjustedPage,
          filter,
          size: PAGE_SIZE,
        });
        commit('updateOfflineState', { page: adjustedPage, total });
        commit('updateOfflineList', newList);
        return newList;
      } catch (err) {
        console.error(err);
        message.error($t('k_ee447943'), err.message);
      }
    },
    // 获取历史版本号
    async fetchSemvers({ commit, rootState }, { projectId } = {}) {
      try {
        const projectID = projectId || rootState.project.projectInfo?.id;
        const result = await offlineService.fetchOfflineList(projectID, {
          size: 'total',
          include: 'semver',
        });
        const semvers = [...new Set(result.map(item => item.semver))];
        commit('updateSemvers', semvers);
      } catch (err) {
        console.error(err);
        message.error($t('k_56d4aed'), err.message);
      }
    },
    async createOffline({ rootState }, { projectId, createData }) {
      try {
        const projectID = projectId || rootState.project.projectInfo?.id;
        const filter = `state = ${OFFLINESTATE.PENDING}`;
        // 获取进行中状态
        const pendingExist = await offlineService.fetchOfflineList(projectID, {
          size: 'total',
          filter,
        });
        if (pendingExist.length !== 0) {
          message.loading(MESSAGES.PENDING);
          return false;
        }
        await offlineService.createOffline({
          projectId: projectID,
          data: createData,
        });
        message.success($t('k_a02e7f65'));
        return true;
      } catch (err) {
        message.error($t('k_3271f4c3', { arg_0: err.message }));
        return false;
      }
    },
    async deleteOffline({ dispatch, rootState }, { projectId, id } = {}) {
      try {
        const projectID = projectId || rootState.project.projectInfo?.id;
        await offlineService.deleteOffline({ projectId: projectID, id });
        dispatch('fetchSemvers', { projectId: projectID });
        message.success($t('k_8385a3b8'));
      } catch (err) {
        message.error($t('k_772c7f8b', { arg_0: err.message }));
      }
    },
    // 自定义离线化配置
    async fetchConfigList({ rootState }, { projectId } = {}) {
      try {
        const projectID = projectId || rootState.project.projectInfo?.id;
        const result = await offlineService.fetchConfigList(projectID, {});
        return result;
      } catch (err) {
        console.error(err);
        message.error($t('k_8246609d'), err.message);
      }
    },
    async createConfig({ rootState }, { projectId, data } = {}) {
      try {
        const projectID = projectId || rootState.project.projectInfo?.id;
        const result = await offlineService.createConfig({
          projectId: projectID,
          data,
        });
        message.success($t('k_9d3170'));
        return result;
      } catch (err) {
        message.error($t('k_2ff0711d', { arg_0: err.message }));
      }
    },
    async updateConfig({ rootState }, { projectId, id, data } = {}) {
      try {
        const projectID = projectId || rootState.project.projectInfo?.id;
        const result = await offlineService.updateConfig({
          projectId: projectID,
          id,
          data,
        });
        if (result) {
          message.success($t('k_8cdae68e'));
        } else {
          message.error($t('k_71d36515'));
        }
        return result;
      } catch (err) {
        message.error($t('k_43b6adee', { arg_0: err.message }));
      }
    },
    async deleteConfig({ rootState }, { projectId, id } = {}) {
      try {
        const projectID = projectId || rootState.project.projectInfo?.id;
        const result = await offlineService.deleteConfig({ projectId: projectID, id });
        if (result) {
          message.success($t('k_16856889', { arg_0: id }));
        } else {
          message.error($t('k_98276eb2'));
        }
        return result;
      } catch (err) {
        message.error($t('k_42198a43', { arg_0: err.message }));
      }
    },
    async debugConfig({ rootState }, { projectId, data } = {}) {
      try {
        const projectID = projectId || rootState.project.projectInfo?.id;
        const debugResult = await offlineService.debugConfig({
          projectId: projectID,
          data,
        });
        if (debugResult.message === SUCCESS) {
          message.success($t('k_c9ea45c8'));
        } else {
          message.error($t('k_14ae8f47'));
        }
        return debugResult;
      } catch (err) {
        message.error($t('k_d386f50e', { arg_0: err.message }));
        return err;
      }
    },
  },
  mutations: {
    updateOfflineList(state, newList) {
      state.offlineList = newList;
    },
    updateOfflineState(state, payload) {
      state.page = payload.page;
      state.total = payload.total;
    },
    updateSemvers(state, semvers) {
      state.semvers = semvers;
    },
    updateOfflineModal(state, isShow) {
      state.showOfflineModal = isShow;
    },
  },
};
